export default "__VITE_ASSET__KduxnqVb__"